import {LOCALE_CATEGORIES} from "@/assets/locales/categories";
import AcceptLegalPopup from "@/domains/-legal/popups/AcceptLegalPopup.vue";
import LegalPopup from "@/domains/-legal/popups/LegalPopup.vue";
import { useSessionStore } from "@/domains/-session/stores/useSessionStore.ts";

import {customAsyncComponent} from "@/functions/customAsyncComponent";
import Home from "@/Home.vue";
import {i18n, loadLocales} from '@/i18n'
import { PopupSize, usePopup } from "omind-design-system/components/odsPopup";
import {createRouter, createWebHistory, RouteLocationNormalized, RouteRecordRaw} from "vue-router";
import {useToast} from "vue-toastification";


const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior (to, from, savedPosition) {
    if(to.hash === '')
      setTimeout(() => {
        const container = document.querySelector('.ods-content-container > div')
        if(container)
          container.scrollTop = 0
      }, 500)
  },
  routes: [
    
    /* {
      name: 'home',
      path: '/home',
      component: () => import('./Home.vue'),
      beforeEnter: (to, from) => {
        
      }
    }, */

    {
      name: 'auth',
      path: '/auth',
      component: () => import('./domains/-auth/views/AuthView.vue'),
      meta: {
        localeCategories: [
          LOCALE_CATEGORIES.AUTH
        ]
      },
      beforeEnter: (to, from) => {
        
      }
    },
    {
      name: 'legal',
      path: '/legal-terms',
      component: () => import('./domains/-legal/views/LegalView.vue'),
      meta: {
        localeCategories: [
          LOCALE_CATEGORIES.LEGAL
        ]
      },
      beforeEnter: (to, from) => {
        
      }
    },
    {
      name: 'bootcamp',
      path: '/',
      component: () => import('./domains/-discussion/views/DiscussionView.vue'),
      meta: {
        requiresAuth: true,
        localeCategories: [
          LOCALE_CATEGORIES.CHATBOT
        ]
      },
      beforeEnter: (to, from) => {
        
      }
    },
    
  ],
})

export function isExactActiveRoute(routeName: string): boolean {
  return router.currentRoute.value.name === routeName
}

export function isActiveRoute(routeName: string): boolean {
  return (
    isExactActiveRoute(routeName)
    || router.currentRoute.value.matched.some(item => item.name === routeName)
  )
}

router.beforeEach(async (to: RouteLocationNormalized) => {
  await loadLocales(LOCALE_CATEGORIES.ERRORS)

  const session = useSessionStore()
  if (Object.hasOwn(to.query, 'pin')){
    await session.setAuthzPin(to.query.pin as string)
    return {name: "bootcamp", query: {} }
  }
    

  const requiresAuth = to.matched.some((record: RouteRecordRaw) => (record.meta && Object.hasOwn(record.meta, 'requiresAuth')) ?? false)
  if (requiresAuth) {
    
    try{
      await session.loadSession()
      if(!session.isAuthenticated)
        return {name: "auth"};
    }
    catch(err){
      console.log(err)
      if(err.status && err.status === 403){
        session.signOut()
        const toast = useToast()
        toast.error(i18n.global.t('errors.expired_pin'))
      }
      
    }

    if(!session.hasAcceptedLegal){
      await loadLocales(LOCALE_CATEGORIES.LEGAL)
      usePopup(AcceptLegalPopup, {
        id: 'popup-accept-legal',
        canClose: false,
        size: PopupSize.Large,
        overflow: false,
        specificClass: '',
        componentProps: {

        }
      })
    }
    
  }


  return;
})

router.beforeResolve(async (to: RouteLocationNormalized) => {
  await loadLocales(LOCALE_CATEGORIES.LEXICON)
  await loadLocales(LOCALE_CATEGORIES.GENERIC)
  if ('hasNav' in to.meta && to.meta.hasNav === true) {
    //await loadLocales(LOCALE_CATEGORIES.NAVIGATION)
  }
  if ('localeCategories' in to.meta) {
    await loadLocales(...(to.meta.localeCategories as LOCALE_CATEGORIES[]))
  }
})

export {router}
export default router